module.exports = __webpack_public_path__ + "static/media/12@1024w.88a94814.jpg";